import React from 'react';
import { WebsiteLayout } from '../../components/WebsiteLayout';
import { ComponentList } from '../../components/ComponentList';
import { ComponentRenderer } from '../../components/ComponentRenderer';

import { PageContextProvider } from '../../contexts/PageContext';
import type { PreviewData } from './types';
import { PreviewModeIndicator } from './PreviewModeIndicator';
import { processLayoutComponents } from '../../utils/templateUtils';

interface PreviewContentProps {
  previewData: PreviewData;
  isEmbedded: boolean;
  isMimicking: boolean;
}

export const PreviewContent: React.FC<PreviewContentProps> = ({
  previewData,
  isEmbedded,
  isMimicking,
}) => {
  console.log(
    '🔍 PagePreview: Rendering with theme:',
    previewData.theme,
    'Site theme:',
    previewData.site.theme,
    'Layout:',
    previewData.layout?.name
  );

  const layoutComponents = previewData.layout?.components || [];
  const { headerComponents: headerLayoutComponents, footerComponents: footerLayoutComponents } =
    processLayoutComponents(Array.isArray(layoutComponents) ? layoutComponents : []);

  return (
    <PageContextProvider
      pageId={previewData.page.id}
      siteId={previewData.site?.id ?? null}
      pageSlug={previewData.page.slug ?? ''}
    >
      <div className={`min-h-screen ${isMimicking && !isEmbedded ? 'mt-[52px]' : ''}`}>
        {!isEmbedded && <PreviewModeIndicator />}

        <WebsiteLayout
          website={previewData.site}
          page={previewData.page}
          navigation={previewData.navigation}
          theme={previewData.theme || previewData.site.theme}
          isPreviewMode={true}
          showBranding={previewData.showBranding}
        >
          {/* Top of page anchor for smooth scroll navigation */}
          <div id="top" />

          {headerLayoutComponents.length > 0 && (
            <div className="layout-header-components">
              {headerLayoutComponents
                .filter((c: any) => c.visible !== false)
                .map((component: any) => (
                  <ComponentRenderer key={component.id} component={component} isEditing={false} />
                ))}
            </div>
          )}

          <ComponentList
            components={previewData.components}
            websiteContext={{
              subdomain: previewData.site.subdomain || '',
              website: previewData.site,
              isPublicView: false,
            }}
          />

          {footerLayoutComponents.length > 0 && (
            <div className="layout-footer-components">
              {footerLayoutComponents
                .filter((c: any) => c.visible !== false)
                .map((component: any) => (
                  <ComponentRenderer key={component.id} component={component} isEditing={false} />
                ))}
            </div>
          )}
        </WebsiteLayout>
      </div>
    </PageContextProvider>
  );
};
